var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMic = function SvgMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 3a2 2 0 0 0-2 2v2.667a2 2 0 0 0 4 0V5a2 2 0 0 0-2-2m0-1.333A3.334 3.334 0 0 1 12.334 5v2.667a3.333 3.333 0 0 1-6.667 0V5A3.333 3.333 0 0 1 9 1.667M3.037 8.334H4.38a4.668 4.668 0 0 0 9.24 0h1.343a6 6 0 0 1-5.296 5.296v2.704H8.334V13.63a6 6 0 0 1-5.297-5.296"
  })));
};
export default SvgMic;